import React, { useCallback, useContext } from 'react';
import { Redirect } from 'react-router';

import { app, providerFacebook, providerGoogle } from '../../firebase';
import { AuthContext } from 'AuthProvider';

const Login = ({history}) => {
  const clickOnFacebook = useCallback(
    async event => {
      event.preventDefault();
      console.log('event', event);
      //const { email, password } = event.target.elements;
      try {
        await app
          .auth()
          .signInWithPopup(providerFacebook);
        //history.push("/");
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );

  const clickOnGoogle = useCallback(
    async event => {
      event.preventDefault();
      console.log('event', event);
      //const { email, password } = event.target.elements;
      try {
        await app
          .auth()
          .signInWithPopup(providerGoogle);
        //history.push("/");
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );

  const { currentUser } = useContext(AuthContext);

  if (currentUser) {
    return <Redirect to="/" />;
  }

	return (
    <div id="login-box" className="login-box visible widget-box no-border">
      <div className="widget-body">
        <div className="widget-main">
          <h4 className="header blue lighter bigger">
            <i className="ace-icon fa fa-cogs blue"></i>
            &nbsp;
            Введите свои данные
          </h4>

          <div className="space-6"></div>

          <form>
            <fieldset>
              <label className="block clearfix">
                <span className="block input-icon input-icon-right">
                  <input type="text" className="form-control" placeholder="E-mail" />
                  <i className="ace-icon fa fa-user"></i>
                </span>
              </label>

              <label className="block clearfix">
                <span className="block input-icon input-icon-right">
                  <input type="password" className="form-control" placeholder="Пароль" />
                  <i className="ace-icon fa fa-lock"></i>
                </span>
              </label>

              <div className="space"></div>

              <div className="clearfix">
                <label className="inline">
                  <input type="checkbox" className="ace" />
                  <span className="lbl"> Запомнит меня</span>
                </label>

                <button type="button" className="width-35 pull-right btn btn-sm btn-primary">
                  <i className="ace-icon fa fa-key"></i>
                  <span className="bigger-110">Войти</span>
                </button>
              </div>

              <div className="space-4"></div>
            </fieldset>
          </form>

          <div className="social-or-login center">
            <span className="bigger-110">ИЛИ войдите используя</span>
          </div>

          <div className="space-6"></div>

          <div className="social-login center">
            <a className="btn btn-primary" onClick={clickOnFacebook}>
              <i className="ace-icon fa fa-facebook"></i>
            </a>

            &nbsp;&nbsp;

            <a className="btn btn-danger" onClick={clickOnGoogle}>
              <i className="ace-icon fa fa-google-plus"></i>
            </a>
          </div>
        </div>
        <div className="toolbar clearfix">
          <div>
            <a href="#" data-target="#forgot-box" className="forgot-password-link">
              <i className="ace-icon fa fa-arrow-left"></i>
              &nbsp;
              Восстановать пароль
            </a>
          </div>

          <div>
            <a href="#" data-target="#signup-box" className="user-signup-link">
              Регистрация
              &nbsp;
              <i className="ace-icon fa fa-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;